import React from 'react';
import BuyButton from '../BuyButton/BuyButton';
import ProductCardProps from './types/ProductCardProps';

const ProductCardBuyButton = ({
  product,
  isVariantListing,
  className,
  label,
}: ProductCardProps) => {
  return (
    <BuyButton
      articleNumber={product.id}
      quantity={product.quantity}
      showQuantityInput={true}
      className={className}
      disabled={
        isVariantListing &&
        (product.canBeBackordered ? false : !product.stockStatus.inStock)
      }
      label={label}
      packagingSize={product.packagingSize}
    />
  );
};

export default ProductCardBuyButton;
